export const HTTP_API_URL = process.env.REACT_APP_HTTP_API_URL;
export const REST_API_URL = process.env.REACT_APP_REST_API_URL;
